<object class="doc" data="https://oneclickres.azureedge.net/pub/fco-policy.pdf?shown=true" type="application/pdf" width="100%">
  <a href="https://oneclickres.azureedge.net/pub/fco-policy.pdf?shown=true">fco-policy.pdf</a>
</object>